module.exports = __webpack_public_path__ + "static/media/get_out_on_shift.8776d285.png";